import React from 'react';
import '../styles/EventsStyle.css';
import moment from 'moment';
import { BiChevronRightCircle, BiFilter, BiFilterAlt } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../settings';
import { displaySnackbar } from '../utilities';

export default function Announcements({ announcements }) {
    const navigate = useNavigate();

    return (
        <div className='announcements'>
            <div className='empty-events-container'>
                {announcements.length <= 0 ? (
                    <>
                        <p className='events-empty-text'>No Announcements for Today</p>

                        <div
                            xyz='fade large duration-20  iterate-infinite'
                            className='events-emptyEmojisDiv'
                        >
                            <p className='events-emptyEmojis xyz-nested'>🗣📢</p>
                        </div>
                    </>
                ) : (
                    <div className='events-list'>
                        {announcements.map((item, index) => (
                            <div
                                key={`event-item #${index}`}
                                className='event-item'
                                onClick={() => navigate(`/info/announcementDetail/${item?.uuid}`)}
                            >
                                <div className='left'>
                                    <p className='event-item-name' style={{ color: '#222' }}>
                                        {item.title}
                                        <BiChevronRightCircle size={30} className='icon' />
                                    </p>

                                    <p
                                        className='upcoming-event-date'
                                        style={{ marginLeft: '.5rem' }}
                                    >
                                        Announced:{' '}
                                        {moment(new Date(item?.createdAt).toISOString()).calendar()}
                                    </p>
                                </div>
                                <div className='right'></div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
